<template>
  <div class="search-page w-full pt-[56px]">
    <!-- 吸顶的导航栏 -->
    <van-nav-bar :title="t('pesquisar.title')" class="custom-nav-bar sticky-nav">
      <template #left>
        <Button type="back" @click="onClickLeft" />
      </template>
    </van-nav-bar>

    <!-- 吸顶的搜索框 -->
    <div class="sticky-search-box px-[8px] mt-[16px]">
      <Border class="w-full" radius="10px" borderWidth="2px">
        <div class="search-box">
          <input v-model="searchText" class="search-input auth-input" type="text"
            :placeholder="t('pesquisar.searchPlaceholder')" @input="onSearch" />
          <van-icon name="search" class="search-icon w-[20px] !flex-shrink-0 color-white" />
        </div>
      </Border>
    </div>
    <!-- 内容区域 -->
    <div class="content-container">
      <!-- 标签栏 -->
      <div class="relative w-full box-border">
        <div class="tab-bar px-[8px]">
          <div v-for="(tab, idx) in tabs" :key="tab.label" class="tab-item" :class="{ active: activeTab === idx }"
            @click="selectTab(idx)">
            <span class="tab-icon flex items-center justify-center">
              <template v-if="tab.icon === 'search'">
                <img :src="getAssetsFile('home/seraces (1).png')" alt="" class="w-[18px] h-[18px]">
              </template>
              <template v-else-if="tab.icon === 'fire'">
                <img :src="getAssetsFile('home/seraces (4).png')" alt="" class="w-[15px] h-[17px]">
              </template>
              <template v-else-if="tab.icon === 'clock'">
                <img :src="getAssetsFile('home/seraces (3).png')" alt="" class="w-[18px] h-[18px]">
              </template>
              <template v-else-if="tab.icon === 'star'">
                <img :src="getAssetsFile('home/seraces (2).png')" alt="" class="w-[14px] h-[15px]">
              </template>
            </span>
            <span class="tab-label">{{ tab.label }}</span>
          </div>


        </div>
        <!-- 统一的横线和高亮指示条 -->
        <div class="tab-bar-underline">
          <div class="tab-bar-active" :style="{
            width: `${90 / tabs.length}%`,
            left: `${(100 / tabs.length) * activeTab}%`,
            transform: 'translateX(15px)',
          }" />
        </div>
      </div>


      <div class="game-list px-[12.5px]">
        <Game class="w-1/3 mt-[10px]" @update:game="changeGame(game)" v-for="game in currentGames" :key="game.id"
          :show-favorite="true" :show-hot="true" :game="game">
        </Game>
      </div>
      <div v-if="currentGames.length === 0">
        <div class="empty-wrap">
          <div class="flex justify-center items-center relative">
            <img :src="getAssetsFile('home/noSearchDataIcon.png')" class="max-h-[131px] max-w-[124.5px] w-auto h-auto">
            <!-- <img :src="getAssetsFile('home/s.png')"
              class="absolute left-[8px] top-1/2 transform -translate-x-1/2 translate-y-1/2 w-[26px] h-[26px]" /> -->
          </div>

          <div class="empty-text">
            {{ t('pesquisar.noGamesAvailable') }}</div>
        </div>
      </div>
    </div>

    <!-- 移除 AuthDialog 组件，因为现在是全局的 -->
    <!-- <AuthDialog
      :show="showAuthDialog"
      :is-login="isLoginMode"
      @close="handleClose"
      @switch="handleSwitch"
    /> -->
  </div>
</template>

<script lang="ts" setup>
import { Game } from "@/components/Game"
import { ref, onMounted, onUnmounted } from 'vue'
import { Button } from "@/components/Button"
import * as GameApi from '@/api/game'
import { useUserStore } from '@/stores/modules/user'
import { useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'
import { Border } from "@/components/Border"
// 移除认证弹窗工具函数导入，因为现在是全局的
// import { showRegisterDialog } from '@/utils/auth-dialog'

const { t } = useI18n()

const onClickLeft = () => history.back()
const searchText = ref('')
const currentGames = ref([])
const userStore = useUserStore()

// 移除本地的认证弹窗状态管理
// const isLoginMode = ref(true)
// const showAuthDialog = ref(false)

const router = useRouter()
const loading = ref(false)
const finished = ref(false)
const pageNo = ref(1)
const pageSize = 20
const route = useRoute()
const total = ref(0)

// tab 列表 - 使用多语言
const tabs = computed(() => [
  { label: t('pesquisar.search'), icon: 'search' },
  { label: t('pesquisar.popular'), icon: 'fire' },
  { label: t('pesquisar.recent'), icon: 'clock' },
  { label: t('pesquisar.favorites'), icon: 'star' },
])

let params = {
  tag: null,
  gameName: null,
  pageNo: 1,
  pageSize: 20,
}
// 当前选中的 tab 索引
const activeTab = ref(1)

onMounted(() => {
  // 设置初始参数为热门标签
  params.tag = 1
  params.gameName = null
  params.pageNo = 1

  // 页面加载时手动触发第一次加载
  onLoad()
  // 添加滚动监听
  window.addEventListener('scroll', handleScroll)
})

onUnmounted(() => {
  // 移除滚动监听
  window.removeEventListener('scroll', handleScroll)
})

// 滚动监听函数
function handleScroll() {
  // 如果正在加载或已经加载完成，则不处理
  if (loading.value || finished.value) return

  // 检查是否滚动到底部
  const scrollTop = window.pageYOffset || document.documentElement.scrollTop
  const windowHeight = window.innerHeight
  const documentHeight = document.documentElement.scrollHeight

  // 当距离底部小于 100px 时触发加载
  if (scrollTop + windowHeight >= documentHeight - 100) {
    loadMore()
  }
}

// 添加去重函数
function removeDuplicateGames(newList, existingList) {
  const existingIds = new Set(existingList.map(game => game.id))
  return newList.filter(game => !existingIds.has(game.id))
}

async function onLoad() {
  if (pageNo.value === 1) {
    currentGames.value = []   // 只要是第一页就清空
  }
  let res
  if (activeTab.value === 3) {
    res = await GameApi.collectList(params)
  } else if (activeTab.value === 2) {
    res = await GameApi.zuigetRecentGames(params)
  } else {
    res = await GameApi.thirdPartyGame(params)
  }
  const list = res.data.list || []
  const newTotal = res.data.total || 0

  if (list.length > 0) {
    // 去重处理：过滤掉已存在的游戏
    const uniqueList = removeDuplicateGames(list, currentGames.value)
    currentGames.value.push(...uniqueList)
    pageNo.value++
    if (currentGames.value.length >= newTotal) {
      finished.value = true
    }
  } else {
    finished.value = true
  }
}

// 加载更多数据
async function loadMore() {
  if (loading.value || finished.value) return

  loading.value = true

  try {
    // 更新页码
    params.pageNo = pageNo.value

    let res
    if (activeTab.value === 3) {
      // Favoritos 标签调用 collectList 接口
      res = await GameApi.collectList(params)
    } else if (activeTab.value === 2) {
      res = await GameApi.zuigetRecentGames(params)
    } else {
      // 其他标签调用 thirdPartyGame 接口
      res = await GameApi.thirdPartyGame(params)
    }

    const list = res.data.list || []
    const newTotal = res.data.total || 0

    if (list.length > 0) {
      // 去重处理：过滤掉已存在的游戏
      const uniqueList = removeDuplicateGames(list, currentGames.value)
      currentGames.value.push(...uniqueList)
      pageNo.value++
    }

    // 检查是否加载完成
    if (currentGames.value.length >= newTotal) {
      finished.value = true
    }
  } catch (error) {
    console.error('加载更多数据失败:', error)
  } finally {
    loading.value = false
  }
}

async function selectTab(idx) {
  activeTab.value = idx
  pageNo.value = 1
  finished.value = false
  currentGames.value = []

  // 重置参数
  params.pageNo = 1

  // 切换 tab 时，如果是搜索 tab (idx === 0) 且有搜索内容，使用搜索参数
  if (idx === 0) {
    // 搜索标签：只有当有搜索内容时才调用接口
    if (searchText.value && searchText.value.trim() !== '') {
      params.gameName = searchText.value
      params.tag = null
      // 有搜索内容时才调用接口
      await onLoad()
    } else {
      // 没有搜索内容时，currentGames 保持为空数组，不调用接口
      params.gameName = null
      params.tag = null
      return // 直接返回，不调用 onLoad()
    }
  } else {
    // 其他标签：根据标签类型设置 tag，清空 gameName
    params.gameName = null
    // 直接使用 tab 索引作为 tag 值
    params.tag = idx

    // 其他标签都调用接口
    await onLoad()
  }
}

// 搜索时重置
async function onSearch() {
  // 无论当前在哪个 tab，搜索时都强制切换到搜索 tab
  activeTab.value = 0
  pageNo.value = 1
  finished.value = false
  currentGames.value = []

  // 设置搜索参数
  if (searchText.value && searchText.value.trim() !== '') {
    params.gameName = searchText.value
    params.tag = null  // 搜索时设置为null，搜索全部游戏
  } else {
    params.gameName = null
    params.tag = null
  }

  await onLoad()
}

function serchChange() {

}
const changeGame = async (game) => {
  // 如果是在收藏标签页，取消收藏后需要重新请求接口
  if (activeTab.value === 3) {
    // 记录取消收藏前的状态
    const wasCollected = game.collect
    // 更新本地状态（Game 组件已经调用了接口，这里同步状态）
    game.collect = !game.collect

    // 如果是从已收藏变为未收藏（取消收藏），重新请求收藏列表
    if (wasCollected && !game.collect) {
      pageNo.value = 1
      finished.value = false
      params.pageNo = 1
      currentGames.value = []
      await onLoad()
    }
  } else {
    // 其他标签页只更新本地状态
    game.collect = !game.collect
  }
}
// 收藏游戏
async function gocollect(game) {
  const a = userStore.checkLoginStatus()
  if (a) {
    try {
      await GameApi.collect({ gameId: game.id })
      game.collect = true
    } catch (error) {
      console.error('收藏失败:', error)
    }
  } else {
    window.$showRegisterDialog() // 使用全局函数
  }
}

// 取消收藏
async function gocollect2(game) {
  const a = userStore.checkLoginStatus()
  if (a) {
    try {
      await GameApi.uncollect({ gameId: game.id })
      game.collect = false

      // 如果在收藏页面，需要从列表中移除该游戏
      if (activeTab.value === 3) {
        const index = currentGames.value.findIndex(item => item.id === game.id)
        if (index > -1) {
          currentGames.value.splice(index, 1)
        }
      }
    } catch (error) {
      console.error('取消收藏失败:', error)
    }
  } else {
    window.$showRegisterDialog() // 使用全局函数
  }
}
const VITE_PLATFORM = import.meta.env.VITE_PLATFORM
async function gogames(row) {
  const a = userStore.checkLoginStatus()
  if (a) {
    const gamesid = {
      platformId: row.providerId,
      currency: VITE_PLATFORM,
      disableFullScreen: 0,
      gameId: row.gameCode,
      lang: 'en',
      homeUrl: import.meta.env.VITE_BASE_URL || window.location.origin,
      platform: 'H5',
      id: row.id,
    }
    const gameUrl = await GameApi.thirdPartygoGame(gamesid)
    // 记录来源路径
    sessionStorage.setItem('fromPath', route.path)
    // 使用 query 参数传递 URL
    router.push({
      path: '/webview/index2',
      query: {
        rid: gameUrl.data,
      },
    })
  }
  else {
    window.$showRegisterDialog() // 使用全局函数
  }
}

// 移除这些函数，因为现在使用全局状态管理
// function handleClose() {
//   showAuthDialog.value = false
// }
// function handleSwitch(mode) {
//   isLoginMode.value = mode
// }
</script>


<style lang="scss" scoped>
.search-page {
  background: getPath("home/homeBg.png") no-repeat;
  background-size: 100% 100%;
  height: 100vh;
  overflow-y: auto;
}

/* 吸顶导航栏样式 */
.sticky-nav {
  position: fixed !important;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
}

/* 吸顶搜索框 */
.sticky-search-box {
  width: 100%;

  box-sizing: border-box;
}

/* 内容区域，为吸顶元素留出空间 */
.content-container {
  // padding-top: 20px;
  /* 增加顶部间距，确保标签栏不被遮挡 */
  padding-bottom: 18px;
}

.custom-nav-bar {
  height: 56px;
  box-shadow: 0px 2px 3px 0px rgba(0, 0, 0, 0.3), 0px -2px 22px 0px rgba(53, 189, 128, 0.61);

  &>* {
    height: 100%;
  }
}

.search-box {

  height: 42px;
  display: flex;
  align-items: center;
  padding: 0 15px;
  background: getPath("home/searchInputBg.png") no-repeat;
  background-size: calc(100% + 4px) calc(100% + 4px);
  background-position: -2px -2px;
}

.search-input {
  flex: 1;
  border: none;
  outline: none;
  background: transparent;
  color: #ADB1B0;
  font-size: 17px;
  height: 100%;
}

input::placeholder {
  color: #ADB1B0;
  font-size: 14px;
}

.search-btn {
  background: none;
  border: none;
  cursor: pointer;
  padding: 0 4px;
  display: flex;
  align-items: center;
}

.auth-input {
  caret-color: #ADB1B0;
}

.tab-bar {
  display: flex;
  align-items: center;
  overflow: hidden;
  justify-content: space-between;
  // background: getPath("home/searchabBg.png") no-repeat;
  background-size: 100% 100%;
  // gap: 15px;
  position: relative;
  // margin-top: 15px;
  // margin-bottom: 20px;
  padding: 10px 0;
  /* 增加内边距 */
}

.tab-item {
  display: flex;
  align-items: center;
  cursor: pointer;
  position: relative;
  font-size: 12px;
  font-weight: 600;
  color: #ADB1B0;
  transition: color 0.2s;
  user-select: none;
  justify-content: center;
  min-width: 0;
  flex: 1;
  /* 让每个标签平均分配空间 */
  padding: 5px 0;
  /* 增加垂直内边距 */
}

.tab-item:last-child {
  margin-right: 0;
}

.tab-item.active {
  position: relative;
  z-index: 9;
  color: #fff;
}

.tab-item .tab-icon {
  font-size: 13px;
  margin-right: 2px;
}

.tab-item .tab-label {
  margin-left: 2px;
  white-space: nowrap;
  /* 防止文字换行 */
}

.tab-bar-underline {
  position: absolute;
  right: 0;
  bottom: 0;
  height: 5px;
  background: getPath("home/tab-bar-underline.png") no-repeat;
  background-size: 100% 100%;
  border-radius: 2px;
  width: 100%;
  z-index: 1;
}

.tab-bar-active {
  position: absolute;
  top: -41px;
  bottom: 0;
  background: getPath("home/tab-bar-underline-activeBg.png") no-repeat;
  background-size: 100% 100%;
  border-radius: 2px;
  transition:
    left 0.2s,
    width 0.2s;
  z-index: 2;
  height: 44px;

}

.game-list {

  // grid-template-columns: repeat(3, .8fr);
  // gap: 10px;
  // margin: 20px 8px;

}

.game-card {
  aspect-ratio: 7/9;
  width: 100%;
  background: #11412f;
  border-radius: 10px;
  overflow: hidden;
  cursor: pointer;
  position: relative;
}

.empty-wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 115px 0 0 0;
}



.empty-text {
  color: #ADB1B0;
  font-size: 12px;
  margin-top: 16px;
}

/* 响应式调整 */
@media (max-width: 480px) {


  .content-container {
    padding-top: 20px;
    /* 小屏幕减少间距 */
  }

  .tab-bar {
    gap: 10px;
  }

  .tab-item {
    font-size: 11px;
  }
}
</style>
